export const data = [
  {
    plansInfo: "Mobile",
    price: "4000",
    quality: "Good",
    resol: "480p",
    canWatch: "mobile"
  },
  {
    plansInfo: "Basic",
    price: "5000",
    quality: "Good",
    resol: "480p",
    canWatch: "Tab"
  },
  {
    plansInfo: "Standard",
    price: "6000",
    quality: "Good",
    resol: "480p",
    canWatch: "Tv"
  },
  {
    plansInfo: "Premium",
    price: "8000",
    quality: "Good",
    resol: "480p",
    canWatch: "Tv"
  }
];
